import {CDN_URL} from "../utils/constants"

const RestaurantCard = (props) => {
    const{resData} = props; //destructuring the props (props is react) and destructuring is js
    
    const {
        name,
     cuisines, 
     avgRatingString,
     costForTwo,
     slaParshu = {}} = resData?.info;
    
    
    return (
         <div className = "res-card p-4 rounded-lg bg-white shadow-lg hover:shadow-xl transition duration-300 ease-in-out"> 
            <img 
            className = "rounded-lg w-full h-36 object-cover"
            alt="res-logo"
            src = {CDN_URL + resData.info.cloudinaryImageId}
            />
            {/* 
            <h3>{resData.info.name}</h3>
            <h4>{resData.info.cuisines.join(", ")}</h4>
            <h4>{resData.info.avgRatingString} stars</h4>
            <h4>{resData.info.costForTwo}</h4>
            <h4>{resData.info.sla.deliveryTime} minutes</h4> 
            This is not a good practice to write the code
            so we have destructuree the code above and now you
            can see the below example; 
            */}
            
           
 
            <h3 className="font-bold text-lg py-2">{name}</h3>
            <h4 className="text-sm text-gray-600">{cuisines.join(", ")}</h4>
            <h4 className="text-sm text-green-600 font-semibold">{avgRatingString} stars</h4>
            <h4 className="text-sm text-gray-800">{costForTwo}</h4>
            <h4 className="text-sm text-gray-600">{slaParshu.deliveryTime} minutes</h4>
 
 
         </div>
     )
 }

//Higher order Component
//input - RestaurantCard => RestaurantCardPromoted
export const withPromotedLabel = (RestaurantCard) =>{
    return(props) => {
        return(<div className="relative">
            <label className="absolute top-0 left-0 bg-red-600 text-white text-xs font-bold m-2 p-1 rounded-md shadow-md">Promoted</label>
            <RestaurantCard {...props}/>
        </div>);
    };
};


 export default RestaurantCard;